import { hasOwnProperty as t } from "./_setup.js";
function l(l, r) {
  return null != l && t.call(l, r);
}
export { l as default };